import { render, staticRenderFns } from "./BubblePromocodes.vue?vue&type=template&id=36008c84&"
import script from "./BubblePromocodes.vue?vue&type=script&lang=ts&"
export * from "./BubblePromocodes.vue?vue&type=script&lang=ts&"
import style0 from "./BubblePromocodes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports